import { render, staticRenderFns } from "./TriggerLogTable.vue?vue&type=template&id=0638297a"
import script from "./TriggerLogTable.vue?vue&type=script&lang=js"
export * from "./TriggerLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports